declare interface MRCForm {
  formElement: HTMLFormElement;
  inputList: (HTMLInputElement | HTMLTextAreaElement)[];
  submitButton?: HTMLButtonElement;
  addEventListener: (
    eventName: string,
    callbackFn: (event: Event) => void
  ) => void;
  registerInputs: (
    inputList: (HTMLInputElement | HTMLTextAreaElement)[]
  ) => void;
  registerSubmitButton: (buttonElement: HTMLButtonElement) => void;
}

export class Form implements MRCForm {
  formElement: HTMLFormElement;
  inputList: (HTMLInputElement | HTMLTextAreaElement)[] = [];
  submitButton?: HTMLButtonElement;

  constructor(formElement: HTMLFormElement) {
    this.formElement = formElement;
    this.inputList = [];

    this.addEventListener = this.addEventListener.bind(this);
    this.registerInputs = this.registerInputs.bind(this);
    this.registerSubmitButton = this.registerSubmitButton.bind(this);
  }

  addEventListener(eventName: string, callbackFn: (event: Event) => void) {
    this.formElement.addEventListener(eventName, callbackFn);
  }

  registerInputs(inputList: (HTMLInputElement | HTMLTextAreaElement)[]) {
    inputList.forEach((input) => {
      this.inputList.push(input);
    });
  }

  registerSubmitButton(buttonElement: HTMLButtonElement) {
    this.submitButton = buttonElement;
  }
}
